import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash.truncate';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';

import Avatar from 'venuescanner-js/react/components/Inbox/components/Objects/Avatar';
import Tooltip from 'venuescanner-js/react/components/Tooltip';

function ContactDetails({ user, thread }) {
  const trackField = field => () => {
    inboxService.trackContactDetailsReveal({ _id: thread._id, field });
  };

  if (!user) {
    return null;
  }

  const userPhone = () => {
    if (user?.phone) {
      return <ContactField value={user.phone} onClick={trackField('phone')} />;
    }

    return (
      <Tooltip
        title='This organiser has chosen not to provide their phone number. If you would like to call them, try asking for their phone number in a message.'
        arrow
        enterTouchDelay={1}
        placement='top'
        icon={null}
        PopperProps={{
          sx: {
            zIndex: 10000,
          },
        }}
      />
    );
  };

  return (
    <div className='enquiry-panel__contact-details'>
      <div className='enquiry-panel__contact-details-photo-container'>
        <Avatar
          names={getAvatarNames(user)}
          size={'medium'}
          isCircle
          imageUrl={user.profile_photo}
        />
      </div>
      <div>
        {user?.email && (
          <ContactField value={user.email} onClick={trackField('email')} />
        )}
        {userPhone()}
      </div>
    </div>
  );
}

function getAvatarNames(organiser) {
  const firstName = organiser.name || null;
  const lastName = organiser.lastName || null;
  const names = [];
  if (firstName) names.push(firstName);
  if (lastName) names.push(lastName);

  return names;
}

function ContactField({ value, onClick }) {
  const [isHidden, setHidden] = useState(true);

  useEffect(() => {
    setHidden(true);
  }, [value]);

  const handleClick = () => {
    setHidden(false);
    onClick();
  };
  if (isHidden) {
    return (
      <p>
        {truncate(value, { length: 9 })}
        <button onClick={handleClick}>Show more...</button>
      </p>
    );
  }

  return <p>{value}</p>;
}

ContactDetails.propTypes = {
  user: PropTypes.shape({
    phone: PropTypes.string,
    email: PropTypes.string,
    profile_photo: PropTypes.string,
  }),
  thread: PropTypes.shape({
    _id: PropTypes.string,
  }),
};

ContactField.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
};

export default ContactDetails;
